import { ErrorPage } from 'components/errorpage'
export const CheckUserAccess = (source: string, resource: string, user_id: string, record: any, userRole: string) => {
  console.log('acessssss', userRole, record, source)
  if (record !== undefined && source !== undefined && resource !== undefined && user_id !== undefined && userRole !== undefined) {
    if (source === 'work_request' && resource === 'show') {
      //   console.log('check--------', source, resource, userRole, user_id, record)
      if (userRole === 'qcreator' && (record?.request_type === 'Q' || record?.request_type === 'PC')) {
        if (record?.creator_id === user_id) {
          return 200
        } else {
          return 403
          // console.log('check--------', 'else')
          // return <ErrorPage />
        }
      }
      if (userRole === 'variantcreator' && record?.request_type === 'V') {
        if (record?.creator_id === user_id) {
          return 200
        } else {
          return 403
          // console.log('check--------', 'else')
          // return <ErrorPage />
        }
      } else if (userRole === 'admin' || userRole === 'srmanager' || userRole === 'qbincharge' || userRole === 'productmanager') {
        return 200
      } else if (userRole === 'qreviewer') {
        if (record?.reviewer_ids?.includes(user_id)) {
          return 200
        } else {
          return 403
          // return <ErrorPage />
        }
      } else if (userRole === 'qapprover') {
        if (record?.all_approver_ids?.includes(user_id)) {
          return 200
        } else {
          return 403
          // return <ErrorPage />
        }
      } else if (userRole === 'subjectincharge') {
        if (record?.created_by === user_id && record?.subject_incharge_id === null) {
          return 200
        } else if (record?.subject_incharge_id === user_id) {
          return 200
        } else {
          return 403
          // return <ErrorPage />
        }
      } else if (userRole === 'systemsupport') {
        if (record?.created_by === user_id) {
          return 200
        } else {
          return 403
        }
      }
    } else if (source === 'question' && resource === 'show') {
      if (userRole === 'qcreator' || userRole === 'variantcreator') {
        if (record?.creator_id === user_id || record?.created_by === user_id) {
          return 200
        } else if (userRole === 'qcreator' && record?.created_by === user_id && record?.request_type === 'Uploaded') {
          return 200
        } else {
          return 403
          // console.log('check--------', 'else')
          // return <ErrorPage />
        }
      } else if (userRole === 'admin' || userRole === 'srmanager' || userRole === 'qbincharge' || userRole === 'productmanager') {
        return 200
      } else if (userRole === 'qreviewer') {
        if (record?.reviewer_id === user_id) {
          return 200
        } else if (record?.second_reviewer_id === user_id) {
          return 200
        } else {
          return 403
          // return <ErrorPage />
        }
      } else if (userRole === 'qapprover') {
        if (record?.approver_id === user_id) {
          return 200
        } else if (record?.second_approver_id === user_id) {
          return 200
        } else {
          return 403
          // return <ErrorPage />
        }
      } else if (userRole === 'subjectincharge') {
        return 200
        // if (record?.work_request?.created_by === user_id) {
        //   return 200
        // } else {
        //   return 403
        //   // return <ErrorPage />
        // }
      } else if (userRole === 'papersetter') {
        if (record?.creator_id === user_id) {
          return 200
        } else {
          return 403
        }
      } else if (userRole === 'systemsupport') {
        if (record?.created_by === user_id) {
          return 200
        } else {
          return 403
        }
      }
    } else if (source === 'papers' && resource === 'show') {
      if (userRole === 'papersetter') {
        if (record?.current_paper_setter_id === user_id) {
          return 200
        } else {
          return 403
        }
      } else if (userRole === 'paperapprover') {
        if (record?.paper_approver_id === user_id) {
          return 200
        } else {
          return 403
        }
      } else if (userRole === 'productmanager') {
        // if (record?.paper_request?.created_by === user_id) {
        //   return 200
        // } else {
        //   return 403
        // }
        return 200
      } else if (userRole === 'admin' || userRole === 'srmanager') {
        return 200
      }
    } else if (source === 'papers' && resource === 'edit') {
      if (userRole === 'papersetter') {
        if (record?.current_paper_setter_id === user_id) {
          return 200
        } else {
          return 403
        }
      } else if (userRole === 'paperapprover') {
        if (record?.paper_approver_id === user_id) {
          return 200
        } else {
          return 403
        }
      } else if (userRole === 'admin' || userRole === 'srmanager') {
        return 200
      }
    } else if (source === 'cleanup' && resource === 'show') {
      if (userRole === 'qbincharge' || 'admin') {
        return 200
      } else {
        return 403
      }
    } else if (source === 'paper_requests' && resource === 'show') {
      if (userRole === 'papersetter') {
        if (record?.paper_setter_id === user_id) {
          return 200
        } else {
          return 403
        }
      } else if (userRole === 'paperapprover') {
        if (record?.paper_approver_id === user_id) {
          return 200
        } else {
          return 403
        }
      } else if (userRole === 'productmanager') {
        // if (record?.created_by === user_id) {
        //   return 200
        // } else {
        //   return 403
        // }
        return 200
      } else if (userRole === 'admin' || userRole === 'srmanager' || userRole === 'qbincharge') {
        return 200
      }
    } else if (source === 'national_average') {
      if (userRole === 'admin' || userRole === 'productmanager') {
        return 200
      } else {
        return 403
      }
    } else if (source === 'project_setup') {
      if (userRole === 'admin') {
        return 200
      } else {
        return 300
      }
    }
  } else {
    return 200
  }
}
